import api from "../api";

const base = "/v1/rentals/assets";

export default {
  listAssets: async (params = {}) => {
    const res = await api.get(base, { params });
    return res.data;
  },
  getAsset: async (id) => {
    const res = await api.get(`${base}/${id}`);
    return res.data;
  },
  createAsset: async (payload) => {
    const res = await api.post(base, payload);
    return res.data;
  },
  updateAsset: async (id, payload) => {
    const res = await api.put(`${base}/${id}`, payload);
    return res.data;
  },
  deleteAsset: async (id) => {
    const res = await api.delete(`${base}/${id}`);
    return res.data;
  },
};
